const labelProposal = idx => {
  return `P${parseInt(idx + 1, 10)
    .toString()
    .padStart(2, '0')}`;
};

export default labelProposal;
